<template>
  <div class="reward-list-section">
    <template v-if="rewardDataList.length > 0">
      <ul class="reward-list-section__list">
        <li
          v-for="item in rewardDataList"
          :key="item.videoContentsId"
          class="reward-list-section__item"
        >
          <reward-item-section :reward="item" />
        </li>
      </ul>
    </template>
    <template v-else>
      <p class="reward-list-section__no-data" v-html="$tc('RewardPage.noData')"></p>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import RewardItemSection from '@/components/RewardPage/RewardPane/RewardItemSection.vue'
import type { RewardDataType } from '@/store/hook/videoPlatformContents/useRewards'

export default defineComponent({
  name: 'RewardListSection',
  components: { RewardItemSection },
  props: {
    rewardDataList: {
      type: Array as PropType<Array<RewardDataType>>,
      default: () => [],
    },
  },
})
</script>

<style scoped lang="scss">
.reward-list-section {
  padding: 24px 14px;

  @media screen and (min-width: $responsiveTabletWidth - 1px) {
    padding-right: 16px;
    padding-left: 16px;
  }

  &__item {
    padding: 8px 0;
    border-bottom: 1px solid $black10;
  }

  &__no-data {
    padding: 7px 0;
    font-family: $fontSignup;
    font-weight: 500;
    font-size: 12px;
    line-height: 1.67;
    text-align: center;
    letter-spacing: 0.02em;
    font-feature-settings: 'palt' on;
    color: $gray50;
  }
}
</style>
